import React from 'react';
import { Navbar } from 'react-bootstrap';
import '../styles/Header.css';

const Header = () => {
    return (
        <Navbar bg="dark" variant="dark" className="header-navbar" sticky="top">
            <Navbar.Brand className="header-brand">
                <span className="brand-icon">🚀</span>
                <span className="brand-text">ML Studio</span>
            </Navbar.Brand>
        </Navbar>
    );
};

export default Header;
